import axios from './axios';

/**
 * サーバー生成 CSV を認証付きでダウンロードする共通ユーティリティ。
 *
 * - 認証は Bearer ヘッダ (axios interceptor が付与) のため <a href> 直リンクは使えない。
 *   blob で受けて createObjectURL → a.click でダウンロードさせる。
 * - responseType:'blob' ではエラーレスポンス (403/422 JSON) も Blob になるため、
 *   ここで text → JSON に戻してメッセージを取り出す (呼び出し側は message を toast に出すだけでよい)。
 */
export async function downloadCsv(
  url: string,
  params: Record<string, string | number | undefined>,
  fallbackFilename: string,
): Promise<void> {
  try {
    const response = await axios.get<Blob>(url, {
      params,
      responseType: 'blob',
      // 大件数ストリーミングを考慮しデフォルト 30s より長く取る
      timeout: 120000,
    });

    const disposition = String(response.headers['content-disposition'] ?? '');
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match?.[1] ?? fallbackFilename;

    const blobUrl = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error: any) {
    // Blob のエラーレスポンスを JSON に戻してメッセージを取り出す
    const data = error?.response?.data;
    if (data instanceof Blob) {
      let message = 'エクスポートに失敗しました';
      try {
        const parsed = JSON.parse(await data.text());
        message = String(
          parsed?.message ?? Object.values(parsed?.errors ?? {}).flat()[0] ?? message,
        );
      } catch {
        // JSON でないボディはデフォルト文言のまま
      }
      throw new Error(message);
    }
    throw new Error(error?.message ?? 'エクスポートに失敗しました');
  }
}
